/**
 * 글쓰기 버튼 버전 선택기
 * props 또는 환경변수로 버전을 동적으로 전환 가능
 */ import React from 'react';
// 세 가지 버전 import
import { WriteButton as WriteButtonOriginal } from './WriteButton';
import WriteButtonHeroUI from './WriteButton.heroui';
import WriteButtonTabs from './WriteButton.tabs';
export const WriteButtonSelector = ({ version = 'heroui', ...props })=>{
    // 환경 변수로도 버전 제어 가능
    const envVersion = process.env.REACT_APP_WRITE_BUTTON_VERSION;
    const finalVersion = envVersion || version;
    switch(finalVersion){
        case 'original':
            return /*#__PURE__*/ React.createElement(WriteButtonOriginal, props);
        case 'tabs':
            return /*#__PURE__*/ React.createElement(WriteButtonTabs, props);
        case 'heroui':
        default:
            return /*#__PURE__*/ React.createElement(WriteButtonHeroUI, props);
    }
};
export default WriteButtonSelector;
